export default __webpack_public_path__ + "static/nicole2-a9dfa2b3c9fe8df7e41b915f59602352.png";